import { ReactNode } from 'react';

import {
  ChakraFlex,
  ChakraSpacer,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

const { h4 } = EquipUITheme.typography;

interface HeaderProps {
  actions?: ReactNode;
  title: string;
  titleIconRight?: ReactNode;
}

const Header = ({ actions, title, titleIconRight }: HeaderProps) => {
  return (
    <ChakraFlex align="center" width="100%">
      <ChakraText
        {...h4}
        fontWeight={500}
        id={`${title.toLowerCase().split(' ').join('-')}__header-title`}
      >
        {title}
      </ChakraText>
      {titleIconRight}
      <ChakraSpacer />
      {actions}
    </ChakraFlex>
  );
};

export default Header;
